import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Breadcrumbs = ({ items = [], styles = [] }) => {
  if (!items || items.length === 0) return null;

  // Ensure absolute URLs for schema (use PUBLIC_URL if present)
  const makeAbsolute = (u) =>
    u && (u.startsWith("http://") || u.startsWith("https://"))
      ? u
      : `${process.env.REACT_APP_PUBLIC_URL || ""}${u}`;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: (it && it.name) || "",
      item: makeAbsolute(it && it.url),
    })),
  };

  return (
    <>
      <nav aria-label="Breadcrumb" className={styles} id="breadcrumb">
        <ol className="breadcrumb">
          {items.map((it, idx) => {
            const isLast = idx === items.length - 1;
            const name = it.name;
            const url = it.url;
            return (
              <li
                key={idx}
                className={`breadcrumb-item ${isLast ? "active" : ""}`}
                aria-current={isLast ? "page" : undefined}
              >
                {isLast ? (
                  <span dangerouslySetInnerHTML={{ __html: name }} />
                ) : (
                  <Link to={url}>
                    <span dangerouslySetInnerHTML={{ __html: name }} />
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>

      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>
    </>
  );
};

export default Breadcrumbs;